import { render, staticRenderFns } from "./DonutChart24.vue?vue&type=template&id=d13d457c&scoped=true&"
import script from "./DonutChart24.vue?vue&type=script&lang=js&"
export * from "./DonutChart24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d457c",
  null
  
)

export default component.exports